import React from 'react'
import getTemplatesReducer from '../../state/templates/get-templates/reducer'
import getTemplateReducer from '../../state/templates/get-template/reducer'
import getTemplateAuditsReducer from '../../state/templates/get-template-audits/reducer'

import {getTemplates, getNextPageTemplate} from '../../state/templates/get-templates/actions'
import {getTemplate} from '../../state/templates/get-template/actions'
import {updateTemplate} from '../../state/templates/edit-template/actions'
import {deleteTemplate} from '../../state/templates/delete-template/actions'
import {
  getTemplateAudits,
  updateTemplateAuditList,
} from '../../state/templates/get-template-audits/actions'
import {updateAuditsCount} from '../../state/templates/updateAuditsCount/actions'

const TemplatesContext = React.createContext()

function TemplatesContextProvider(props) {
  const [templateParams, setTemplateParams] = React.useState({
    due_filter: '0',
    query: '',
    column_name: 'name',
    sort_by: 'ASC',
    limit: 25,
    type: 'template',
  })

  const [template, templateDispatch] = React.useReducer(getTemplateReducer, '')
  const [templates, templatesDispatch] = React.useReducer(getTemplatesReducer, '')
  const [templateAudits, templateAuditsDispatch] = React.useReducer(getTemplateAuditsReducer, '')

  const selectTemplate = React.useCallback((data = {}) => getTemplate(data, templateDispatch), [])
  const getAllTemplates = React.useCallback(
    (params = {}) => getTemplates(params, templatesDispatch),
    []
  )

  const getNextTemplates = React.useCallback(
    (params = {}) => getNextPageTemplate(params, templatesDispatch),
    []
  )

  const getAudits = React.useCallback(id => getTemplateAudits(id, templateAuditsDispatch), [])

  const editTemplate = React.useCallback(
    (id, params = {}) => updateTemplate(id, params, templatesDispatch),
    []
  )

  const removeTemplate = React.useCallback(id => deleteTemplate(id, templatesDispatch), [])

  const updateTemplateCount = React.useCallback(id => updateAuditsCount(id, templatesDispatch), [])

  const updatedTemplateAuditList = React.useCallback(
    list => updateTemplateAuditList(list, templateAuditsDispatch),
    []
  )

  const value = {
    template,
    templates,
    templateParams,
    templateAudits,

    selectTemplate,
    removeTemplate,
    getAllTemplates,
    getAudits,
    editTemplate,
    setTemplateParams,
    updateTemplateCount,
    updatedTemplateAuditList,
    getNextTemplates,
  }

  return <TemplatesContext.Provider value={value}>{props.children}</TemplatesContext.Provider>
}

const TemplatesContextConsumer = TemplatesContext.Consumer

export {TemplatesContext, TemplatesContextProvider, TemplatesContextConsumer}
